import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppHeader from "../layout/appHeader";
import LogoutButton from "../common/logoutBtn";
import RefreshAllSummaries from "../common/refreshAll";

const BranchesNav = () => {
  const { t } = useTranslation();
  const { branches } = useSelector((state) => state.branches);
  const owner = branches[0]?.nameSurname;
  const subtitle = owner
    ? `${owner}: ${t("branches.totalB")}`
    : t("branches.totalB");

  return (
    <AppHeader
      breakpoint="md"
      subtitle={<span title={subtitle}>{subtitle}</span>}
      actions={
        <>
          <RefreshAllSummaries />
          <LogoutButton />
        </>
      }
      mobileActions={<RefreshAllSummaries />}
      panelExtra={<LogoutButton />}
    />
  );
};

export default BranchesNav;
